import { render, staticRenderFns } from "./IamMenu.vue?vue&type=template&id=54d1a1fd&"
import script from "./IamMenu.vue?vue&type=script&lang=js&"
export * from "./IamMenu.vue?vue&type=script&lang=js&"
import style0 from "./IamMenu.vue?vue&type=style&index=0&id=54d1a1fd&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports